export default __webpack_public_path__ + "static/media/logo-circle.bf5c5104.svg";